module.exports = __webpack_public_path__ + "img/combo_list.33dd6480.png";